import moment from "moment";

/**
 * カレンダーの初期表示位置設定を取得する
 *
 * 現在時刻からoffset日前の日時を初期表示位置として返す。
 * また、カレンダーの開始日が現在時刻からoffset日前の日時よりも前の場合は、カレンダーの開始日を初期表示位置として返す。
 *
 * @param {Date} startDate SchedulerProのカレンダーの開始日
 * @param {Date} currentDate 現在時刻
 * @param {Number} offset 現在時刻からのオフセット（days）
 * @param {String} block カレンダーの初期表示位置のブロック（デフォルト "start"）
 * @return {Date} カレンダーの初期表示位置
 */
const getVisibleDate = (startDate, currentDate, offset, block) => {
  if (!block) {
    block = "start";
  }

  let offsetDate = moment(currentDate).subtract(offset, "days");
  const startMoment = moment(startDate);

  // カレンダーの開始日が現在時刻からoffset日前の日時よりも前の場合は、カレンダーの開始日を初期表示位置として返す
  if (offsetDate.isBefore(startMoment)) {
    return {
      date: startMoment.toDate(),
      block: block,
    };
  }

  return {
    date: offsetDate.toDate(),
    block: block,
  };
};

export { getVisibleDate };
